import { Grid, TableRow, styled } from '@mui/material';
import Column from 'src/frontend-common/components/Column';

export const TableRowWrapper = styled(TableRow)(() => ({
  '&:hover': {
    backgroundColor: '#F3F4F6',
  },
}));

export const GridCellWrapper = styled('div')(() => ({
  border: '1px solid #F4F5F7',
  display: 'flex',
  flexDirection: 'column',
  height: '165px',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const SkeletonWrapper = styled(Column)(() => ({
  alignItems: 'center',
}));

export const SpecialGridWrapper = styled(Grid)(({ theme }) => ({
  minHeight: 700,
  [theme.breakpoints.down('md')]: {
    minHeight: 1250,
  },
}));

export const RowOnDesktop = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(3),
  flexDirection: 'row',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
  '& svg': {
    '&>g': {
      '&>g': {
        '&:last-of-type': {
          '&>g': {
            '&>g': {
              '&>g': {
                '&>g': {
                  '&>g': {
                    '&>g': {
                      '&>g': {
                        '&>g': {
                          '&>g': {
                            '&>g': {
                              '&>g': {
                                '&>g': {
                                  '&>g': {
                                    '&:first-of-type': {
                                      '&>path': { display: 'none' },
                                    },
                                    '&:last-of-type': {
                                      '&>path': { display: 'none' },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}));
